import { render } from "./AppFooter.vue?vue&type=template&id=64fbc434"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "/dev/shm/repo/portfolio-dp7mkww8fwx8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__